import React from 'react'
import { Heading, Layout, Text } from '@staccx/bento'
import { RightAlignedRow } from '../../../theme/Theme.ItemGroup'
import { TranslatedText } from '@staccx/i18n'
import FleetReportDetailsTable from '../components/FleetTables/FleetReportDetails'
import { useParams } from 'react-router-dom'
import ReportTermSelect from '../components/ReportTermSelect'
import { useCarByAccountNo } from '../../../context/CarProvider'
import { useQuery } from 'react-query'
import { useUserContext } from '../../../context/UserProvider'
import { fetchFleetReportDetails, fetchFleetReportTerms } from '../../../api/api'
import ExcelButton from '../components/ExcelButton'
import Container from '../../../components/Container'

const FleetReportDetails = () => {
  const { account } = useParams()
  const { chosenCompany: company, fleetReportTerm } = useUserContext()
  const companyId = company && company.id
  const car = useCarByAccountNo(account)
  const { make, model, driver = {}, registrationNumber = '' } = car ? car : {}

  const { data: terms = [] } = useQuery(['fleetReportTerms', companyId], () => fetchFleetReportTerms(companyId), {
    enabled: !!companyId,
  })

  const { data: report = [], isLoading: reportLoading } = useQuery(
    ['fleetReportDetails', companyId, fleetReportTerm, account],
    () => fetchFleetReportDetails(companyId, account, fleetReportTerm),
    { enabled: !!companyId }
  )
  // TODO: Fetch car before the table loads? Now it feels like a disconnect, same with expense.
  return (
    <Container>
      <TranslatedText i18nKey={'FLEETREPORT_DETAILS_HEADING'}>
        {(value) => <Heading level="1">{value}</Heading>}
      </TranslatedText>
      <Layout variant="fiftyFifty">
        <div>
          <p>
            <TranslatedText i18nKey="ACCOUNT">
              {(value) => (
                <Text level="4">
                  {value}: {account}
                </Text>
              )}
            </TranslatedText>
          </p>
          <p>
            <TranslatedText i18nKey="REGISTRATION_NUMBER">
              {(value) => (
                <Text level="4">
                  {value}: {registrationNumber}
                </Text>
              )}
            </TranslatedText>
          </p>
          <p>
            <TranslatedText i18nKey="CAR_MAKE_MODEL">
              {(value) => (
                <Text level="4">
                  {value}: {make} {model}
                </Text>
              )}
            </TranslatedText>
          </p>
          <p>
            <TranslatedText i18nKey="DRIVER">
              {(value) => (
                <Text level="4">
                  {value}: {driver.name}
                </Text>
              )}
            </TranslatedText>
          </p>
        </div>

        <TranslatedText i18nKey="TERM">
          {(value) => <ReportTermSelect label={value} reportTerms={terms} />}
        </TranslatedText>
      </Layout>
      <RightAlignedRow>
        <ExcelButton />
      </RightAlignedRow>
      <FleetReportDetailsTable isLoading={reportLoading} data={report} />
    </Container>
  )
}

export default FleetReportDetails
